// eslint-disable-next-line no-unused-vars
import { USER_ROOT, transmission, WEB_METHODS } from '../../network/index'

const ROOT = '/client/contract'

const state = {
    appVersions: [],
    contract: {}
}

const mutations = {
    initContract (state) {
      state.contract = {
          init: false,
          clientNo: '',
          contractEp: '',
          contractStartDateTime: '',
          contractEndDateTime: '',
          hmUseYn: 'N',
          allowsRealtalkService: true,
          goodsNo : 0,
          realtalkMasterNo: null,
          chaImgNo: null,
          rgstYn: null,
          trialActiveDateTime : "",
          trialInactiveDateTime: "",
          trialStatus:"",
          expiredTrial: false,
          trialDays: 0,
          expiredTrialTicket: false
        }

    },
    setContract: (state, contract) => {
      state.contract = contract
    },
    initAppVersions (state) {
      state.appVersions = []
    },
    setAppVersions: (state, appVersions) => {
      state.appVersions = appVersions
    }
}

const actions = {
    /**
       * 사용자 > 사용한 티켓으로 계약상품정보 조회
       *  => 클라이언트 계약정보가 아닌 유저상품(?)ㄴ쪽으로 API 변경해야할듯..
       * @param commit
       * @param payload
       * @returns {Promise<unknown>}
       */
    // eslint-disable-next-line no-unused-vars
    async getContractedGoodsInfo ({commit}, payload) {
       return transmission(true, WEB_METHODS.GET, `${USER_ROOT + ROOT}`)
           .then(res => {
             const {success, data} = res;
             if (success && data) {
               commit('setContract', data.contract)
               commit('setAppVersions', data.app)
             } else {
               commit('initContract')
               commit('initAppVersions')
             }
           })
     }
}

export default { state, mutations, actions }
